// extracted by mini-css-extract-plugin
export default {"box":"styles_box__3fpYH","buttons":"styles_buttons__qHWDe"};